import { FormLabel, Grid, TextField, Typography } from '@mui/material';
import { useProyecto } from '../../../data/ProyectoContext';
import { useActividadesContext } from '../../UmmIACategories/Hook/useActividades';

const Caracterizacion = () => {

    const { proyecto, setProyecto } = useProyecto();
    const {setPromptData, promptData} = useActividadesContext();    

    const handleCharacterizationProyectChange = (event) => {
        const { value } = event.target;
        const caracterizacion = value
        setProyecto({...proyecto, caracterizacion: caracterizacion
        });
        setPromptData((prevData) => ({
            ...prevData,
            caracterizacion: value 
          }));
      };

    
    return (
        <Grid xs={12} lg={12} md={12}>
            <Typography id="modal-modal-title" sx={{ fontFamily: 'montserrat', fontSize: '1.25rem', fontWeight: 'bold', color: '#336B87' }} >Características de los estudiantes </Typography>
            <FormLabel sx={{ fontFamily: 'montserrat', fontSize: '0.85rem' }}> Describe las características comunes de tus estudiantes, incluyendo intereses, fortalezas o dificultades. Puedes también detallar distintos niveles de aprendizaje en el grupo.</FormLabel>
            <TextField
                required
                id="contexto"
                placeholder=' Interés por proyectos medioambientales y trabajo de campo, con fortalezas en investigación pero necesidad de apoyo en expresión escrita.'
                name="contexto"
                fullWidth
                autoComplete="given-name"
                variant="outlined"
                value={promptData.caracterizacion}
                onChange={handleCharacterizationProyectChange}
                InputProps={{
                    sx: {
                        borderRadius:2,
                        mt:1,
                        mb: 3,
                        fontFamily: 'montserrat',
                        fontSize: '0.75rem',
                        color: '#005559',
                        '&::placeholder': {
                            color: '#005559',

                        },
                        '&:before': {
                            borderBottomColor: '#005559',

                        },
                        '&:after': {
                            borderBottomColor: '#005559',
                        },
                    }
                }}
            />
        </Grid>
    );
};

export default Caracterizacion;




